module.exports = __webpack_public_path__ + "images/a79fe77f2170100b5fcb0c0c8fd7c053.png";